import { ToastContainer } from "@risalabs_frontend_org/oasis-ui-kit";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { initScrollbarVisibility } from "./utils/scrollbarVisibility";

initScrollbarVisibility();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <ToastContainer />
    <App />
  </React.StrictMode>,
);
